<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t("breed.breeds") }}</h2>
    </div>
    <el-card
      v-if="checkRole(['Admin'])"
      class="box-card filter-card just-for-admin"
    >
      <div slot="header" class="clearfix">
        <span>{{ $t("general.filter") }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="initSearch"
        >{{ $t("general.init") }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio
          v-model="activeList"
          label="actives"
          border
          @change="getSubBreedsList('indexactive')"
        >{{ $t("general.F_actives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="desactives"
          border
          @change="getSubBreedsList('indexdesactive')"
        >{{ $t("general.F_desactives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="disponibles"
          border
          @change="handleFilterBreeds"
        >{{ $t("general.disponibles") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="corbeille"
          class="danger-radio"
          border
          @change="getSubBreedsList('indexinvisible')"
        >{{ $t("general.corbeille") }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          :placeholder="$t('general.keyword')"
          class="wd-200 mr-15 filter-item"
          @keyup.enter.native="handleFilterBreeds"
        />
        <el-select
          v-model="query.specie_id"
          class="filter-item"
          filterable
          clearable
          :placeholder="$t('specie.specie')"
          @change="handleFilterBreeds"
        >
          <el-option
            v-for="(specie, index) in species"
            :key="index"
            :label="specie.name | uppercaseFirst"
            :value="specie.id"
          />
        </el-select>
        <el-button
          v-waves
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilterBreeds"
        >
          {{ $t("general.search") }}
        </el-button>
        <el-button
          v-waves
          :loading="downloading"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
          @click="handleDownload"
        >
          {{ $t("general.export") }}
        </el-button>
        <el-button
          v-if="checkPermission(['create breed'])"
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateBreed"
        >
          {{ $t("general.add") }}
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column align="center" :label="$t('breed.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('breed.description')">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('specie.specie')" width="200">
          <template slot-scope="scope">
            <span>
              {{ species.find((specie) => specie.id == scope.row.specie_id).name }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            activeList != 'corbeille' && checkPermission(['activate breed'])
          "
          align="center"
          :label="$t('general.status')"
          width="150"
        >
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setBreedStatus(scope.row.id, 'active')"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            checkRole(['Admin']) && (activeList == 'corbeille' || query.keyword)
          "
          align="center"
          :label="$t('general.restaurer')"
          width="100"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setBreedStatus(scope.row.id, 'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPermission(['edit breed', 'hide breed', 'delete breed'])"
          align="center"
          :label="
            1 == 1 ? $t('general.actions') : $t('general.suppressionDefinitive')
          "
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.is_visible && checkPermission(['edit breed'])"
              type="primary"
              size="small"
              icon="el-icon-view"
              style="margin-right: 10px"
              @click="handleEditBreed(scope.row.id)"
            />
            <el-button
              v-if="checkPermission(['hide breed', 'delete breed'])"
              slot="reference"
              type="danger"
              size="small"
              icon="el-icon-delete"
              style="margin-right: 10px"
              @click="
                handleDeleteBreed(
                  scope.row.id,
                  scope.row.is_visible,
                  scope.row.name
                )
              "
            />
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="query.page"
        :limit.sync="query.limit"
        @pagination="getBreedsList"
      />

      <!-- ======= BREED FORM ======= -->
      <el-dialog
        :title="
          editing
            ? $t('breed.edit') + ' ' + currentBreed.name
            : $t('breed.AddBreed')
        "
        :visible.sync="dialogCreateBreed"
        :before-close="handleCloseBreedCreateDraw"
        :loading="breedCreating"
        width="50%"
      >
        <div class="content-inputs">
          <el-form
            ref="breedForm"
            :rules="rules"
            :model="currentBreed"
            label-position="left"
          >
            <el-form-item
              :label="$t('specie.selectSpecieTitle')"
              prop="specie_id"
            >
              <el-select
                v-model="currentBreed.specie_id"
                class="filter-item w-100"
                :placeholder="$t('specie.specie')"
              >
                <el-option
                  v-for="(specie, index) in species"
                  :key="index"
                  :label="specie.name | uppercaseFirst"
                  :value="specie.id"
                  :disabled="!specie.is_active"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('breed.name')" prop="name">
              <el-input v-model="currentBreed.name" />
            </el-form-item>
            <el-form-item :label="$t('breed.description')" prop="description">
              <el-input v-model="currentBreed.description" type="textarea" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align: right">
            <el-button plain type="danger" @click="dialogCreateBreed = false">
              {{ $t("permission.cancel") }}
            </el-button>
            <el-button
              type="primary"
              :loading="breedCreating"
              @click="editing ? updateBreed() : createBreed()"
            >
              {{ breedCreating ? $t("general.saving") : $t("general.save") }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- ======= END BREED FORM ======= -->
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const breedResource = new Resource('breeds');
const specieResource = new Resource('species');
export default {
  name: 'BreedsList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      species: [],
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      breedCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentBreed: {},
      dialogCreateBreed: false,
      currentBreedId: 0,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('breed.NameRequired'),
            trigger: 'blur',
          },
        ],
        specie_id: [
          {
            required: true,
            message: this.$t('specie.specieRequired'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getSpeciesList();
    this.resetNewBreed();
    this.getBreedsList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array) {
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseBreedCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    cancelBreedForm() {
      this.$refs.BreedCreationDrawer.closeDrawer();
    },
    initSearch() {
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterBreeds();
    },
    async getBreedsList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await breedResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubBreedsList(subUrl) {
      this.loading = true;
      const { data } = await breedResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterBreeds() {
      this.query.page = 1;
      this.getBreedsList();
    },
    handleCreateBreed() {
      this.editing = false;
      this.resetNewBreed();
      this.dialogCreateBreed = true;
      this.$nextTick(() => {
        this.$refs['breedForm'].clearValidate();
      });
    },
    handleEditBreed(id) {
      this.editing = true;
      this.resetNewBreed();
      this.currentBreed = this.list.find((abonne) => abonne.id === id);
      this.dialogCreateBreed = true;
      this.$nextTick(() => {
        this.$refs['breedForm'].clearValidate();
      });
    },
    async setBreedStatus(id, type) {
      const data = await breedResource.get('toogle_' + type + '/' + id);
      if (data.success) {
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteBreed(id, visible, name) {
      this.$confirm(
        this.$t('breed.deleteWarn') +
          ' ' +
          name +
          '. ' +
          this.$t('general.deleteContinue'),
        'Warning',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: this.$t('general.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          if (
            !visible &&
            (checkRole(['Admin']) || checkPermission(['delete breed']))
          ) {
            this.$swal({
              title: this.$t('general.SureQuestion'),
              text: this.$t('general.irrversibleMessage'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.$t('general.ouiSupprimer'),
            }).then((result) => {
              if (result.isConfirmed) {
                breedResource
                  .destroy(id)
                  .then((response) => {
                    this.$message({
                      type: 'success',
                      message: this.$t('breed.suppressionEffectue'),
                    });
                    this.initSearch();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            });
          } else {
            this.setBreedStatus(id, 'visible');
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general.suppressionAnnule'),
          });
        });
    },
    createBreed() {
      this.$refs['breedForm'].validate((valid) => {
        if (valid) {
          this.breedCreating = true;
          breedResource
            .store(this.currentBreed)
            .then(async(response) => {
              this.$message({
                message:
                  this.$t('breed.NewBreed') +
                  ' ' +
                  this.currentBreed.name +
                  ' ' +
                  this.$t('breed.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentBreedId = response.data.id;
              this.resetNewBreed();
              this.dialogCreateBreed = false;
              this.handleFilterBreeds();
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.breedCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateBreed() {
      this.$refs['breedForm'].validate((valid) => {
        if (valid) {
          this.breedCreating = true;
          breedResource
            .update(this.currentBreed.id, this.currentBreed)
            .then((response) => {
              this.resetNewBreed();
              this.handleFilterBreeds();
              this.$message({
                message: this.$t('breed.isupdatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.dialogCreateBreed = false;
              this.editing = false;
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.breedCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewBreed() {
      this.currentBreed = {
        name: '',
      };
    },
    async getSpeciesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await specieResource.list(this.query);
      this.species = data;
      this.species.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'ID',
          this.$t('breed.name'),
          this.$t('specie.specie'),
        ];
        const filterVal = ['id', 'name', 'specie_id'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            'Breeds list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
  width: 70% !important;
  float: none !important;
  text-align: left !important;
  padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
